import { Controller } from "@hotwired/stimulus"

const STEP_FRAME_ID = "step"

export default class extends Controller {
  static targets = ["wrapper"]

  connect() {
    this.onFrameChange = () => this.updateVisibility()
    document.addEventListener("turbo:frame-render", this.onFrameChange)
    document.addEventListener("turbo:frame-load", this.onFrameChange)
    document.addEventListener("turbo:load", this.onFrameChange)
    this.updateVisibility()
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this.onFrameChange)
    document.removeEventListener("turbo:frame-load", this.onFrameChange)
    document.removeEventListener("turbo:load", this.onFrameChange)
  }

  updateVisibility() {
    const frame = document.getElementById(STEP_FRAME_ID)
    if (!frame || !this.hasWrapperTarget) return

    this.wrapperTarget.classList.toggle("hidden", !this.stepPanelOpen(frame))
  }

  stepPanelOpen(frame) {
    return Array.from(frame.children).some(
      (node) => node.nodeType === Node.ELEMENT_NODE
    )
  }
}
